/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m15.9996 2c7.72 0 14 6.28 14 14s-6.28 14-14 14c-7.719 0-14-6.28-14-14s6.281-14 14-14zm0 26c6.618 0 12-5.383 12-12s-5.382-12-12-12c-6.617 0-12 5.383-12 12s5.383 12 12 12zm6.894-6.52c.407.373.435 1.006.062 1.413-.198.215-.467.324-.738.324-.241 0-.483-.087-.676-.262l-6.783-6.218c-.207-.189-.324-.457-.324-.737v-6.217c0-.553.447-1 1-1s1 .447 1 1v5.777z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;